import * as styles from './terms.style.js';
import { cx } from '@emotion/css';

export default function Terms() {
  return (
    <main className={cx(styles.main)}>
      <section class="main content">
        <hgroup>
          <h1>QuizWizard Refund Policy</h1>
          <h2>
            Effective date: Jan 1, 2025; Last updated: April 6, 2025
          </h2>
        </hgroup>

        <p>
          At QuizWizard, we strive to ensure customer satisfaction with our subscription services.
          Please review our refund policy carefully to understand your rights and obligations as a subscriber.


        </p>


        <h4>Monthly Subscriptions</h4>
        <p>
          Monthly subscriptions are non-refundable. Once a monthly charge has been processed, it cannot be refunded, partially or fully. You can cancel your subscription at any time, and you will retain access until the end of your current billing period.</p>

        <h4>Annual Subscriptions</h4>
        <p>
          Annual subscriptions are non-refundable. Once a yearly charge has been processed, it cannot be refunded, partially or fully. You can cancel your subscription at any time, and you will retain access until the end of your current billing period.</p>


        <h4>Accidental Charges</h4>
        <p>
          If you believe you were charged in error or experienced a technical issue that led to an unintended payment, please contact our support team at support@gencoft.com within 7 days of the transaction. We'll investigate and process a refund if applicable.
        </p>


        <h4>Non-Refundable Items</h4>
        <p>
          We do not offer refunds for:
          <li>Subscription renewals past the eligible refund window.</li>
          <li>Accounts that violate our Terms of Service.</li>
          <li>Downgrades during a billing cycle (downgrades take effect from the next billing cycle).</li>
        </p>

        <h4>How to Request a Refund</h4>
        <p>
          To request a refund, please contact us at support@gencoft.com with the following details:
          <li>Your full name</li>
          <li>Email address associated with your account</li>
          <li>Purchase date and amount</li>
          <li>Reason for the refund request</li>

          We typically respond within 2–3 business days, and approved refunds will be processed to your original payment method within 5–10 business days, depending on your payment provider.


        </p>






        <h3>Changes to this Notice</h3>
        <p>
          QuizWizard reserves the right to modify this Refund Policy Notice at any time,
          so please review it frequently. If we materially change how we refund your money, we will notify, by email, and/or by means
          of a notice on our website prior to the change becoming effective. Your continued use of the Service
          constitutes your acceptance of any changes to this Refund Policy Notice.
        </p>


        <h3>Contact Us</h3>
        <p>
          If you have questions or wish to send us comments about this Privacy
          Notice, please write us:


          <a href="mailto:support@gencoft.com" target="email">
            support@gencoft.com
          </a>
          <br />

        </p>
      </section>
    </main >
  );
}
